enum Role {
  ADMIN = 'Admin',
  /**
   * @deprecated Please use INTERNAL_TA_FITTER
   */
  EMPLOYEE_FITTER = 'EmployeeFitter',
  EXTERNAL_TA_FITTER = 'External TA Fitter',
  /**
   * @obsolete This role is no longer in use and there is no replacement. References will be removed in the near future.
   */
  INTERNAL_FITTER = 'InternalFitter',
  INTERNAL_TA_FITTER = 'Internal TA Fitter',
  INTERNAL_TA_LIGHT_FITTER = 'Internal TA Light Fitter',
  /**
   * @deprecated Please use EXTERNAL_TA_FITTER
   */
  PARTNER_FITTER = 'PartnerFitter',
  /**
   * @deprecated Please use OPERATIONS
   */
  OPS = 'Ops',
  OPERATIONS = 'Operations',
}

enum RoleFlag {
  isAdmin = 'isAdmin',
  isFitter = 'isFitter',
  isEmployeeFitter = 'isEmployeeFitter',
  isInternalFitter = 'isInternalFitter',
  isPartnerFitter = 'isPartnerFitter',
  isOperations = 'isOperations',
}

export { Role, RoleFlag }
